// extracted by mini-css-extract-plugin
module.exports = {"EnvSwitcher":"EnvSwitcher_EnvSwitcher__woTmf","Button":"EnvSwitcher_Button__WykXF"};